window.confused = window.confused || {};

confused.fuelCost = (function ($, fuelcost) {

    var $fuelCostCalculator;
    var $userInputReg;

    var carInfo = {
        reg: "",
        make: "",
        model: "",
        mpg: ""
    };

    var $costInfoFields = {};
    var progress = 0;
    var pageTransition;
    var pageTransitionState = ["panel1", "panel2", "panel3", "panel4"];
    var numberOfLtrToGallon = 4.545;

    /* ----------Car Lookup----------*/
    function findCarClickEvent() {
        $userInputReg = $fuelCostCalculator.find("#RegNumber").val();

        if (validRegNumber($userInputReg)) {
            hideErrors();
            clearPrefilledCarLookupValues();
            $fuelCostCalculator.find("#RegLookupAjaxSpinner").show();
            carRegLookup($userInputReg);
        } else {
            $fuelCostCalculator.find("#regerror").slideDown(300);
        }
    }

    function updateCarDetails() {
        setText("#VehicleResultReg", carInfo.reg.toUpperCase());
        setText("#VehicleMake", carInfo.make.toUpperCase());
        setText("#VehicleModel", carInfo.model.toUpperCase());
    }

    function carLookupSuccess(carResult) {
        //do something with car results
        carInfo.reg = $userInputReg;
        carInfo.make = carResult.CarMake;
        carInfo.model = carResult.CarModel;
        carInfo.mpg = carResult.MpgValue;

        //Update Mpg field
        $fuelCostCalculator.find("#MpgValue").val(carInfo.mpg);

        //prefill the values
        updateCarDetails();
        pageTransition.next();
    }

    function carLookupFailure() {
        //No result found, show error message
        $fuelCostCalculator.find("#searcherror").slideDown(300);
        $fuelCostCalculator.find("#regerror").slideUp(300);
        $fuelCostCalculator.find("#RegLookupAjaxSpinner").hide();
    }

    function carRegLookup(registration) {

        var jsonData = "{'registrationNumber': '" + registration + "'}";

        $.ajax({
            url: "/api/GetVehicleFuelCostDetails",
            cache: false,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: jsonData,
            success: function (result) {
                if (result.VehicleResultFound) {
                    // toggle text for assume/estimated mpg value. 
                    if (result.VehicleValuesAssumed === true) {
                        $fuelCostCalculator.find(".mpgEstimated").hide();
                        $fuelCostCalculator.find(".mpgAssumed").show();
                    } else {
                        $fuelCostCalculator.find(".mpgEstimated").show();
                        $fuelCostCalculator.find(".mpgAssumed").hide();
                    }
                    $fuelCostCalculator.find("#RegLookupAjaxSpinner").hide();
                    carLookupSuccess(result);
                } else {
                    carLookupFailure();
                }
            },
            error: function () {
                carLookupFailure();
            }
        });
    }

    /* ----------Validation----------*/

    function hideErrors() {
        $fuelCostCalculator.find(".error").hide();
    }

    function validRegNumber(regNumber) {
        if (regNumber === "" || !regNumber.match("^[a-zA-Z0-9 -]{2,10}$")) {
            return false;
        }
        return true;
    }

    //Checks against numeric fields. Allows a single or no decimal point and no letters. 
    function validNumberValue(numericInput) {
        if (numericInput === "" || !numericInput.match("^[0-9]*[\.]{0,1}[0-9]*$")) {
            return false;
        }
        return true;
    }

    //Deals with checking number inputs. If not valid and an error message is available it will show that message.
    function numberInputCheck() {
        var $this = $(this);
        var nextEl = $this.next();
        if (!validNumberValue($this.val())) {
            if (nextEl.hasClass("error")) {
                $this.next().show();
            }
            //invalid
            return false;
        } else {
            if (nextEl.hasClass("error")) {
                $this.next().hide();
            }
            //valid
            return true;
        }
    }

    /* ----------Prefill and Cleanup----------*/

    //Clears 
    function clearPrefilledCarLookupValues() {
        $.each(carInfo, function (i) {
            carInfo[i] = "";
        });
        updateCarDetails();
    }

    function setText(el, text) {
        $fuelCostCalculator.find(el).text(text);
    }

    function calculateResult() {
        $costInfoFields.fuel.val($("#fuelCostPerLitre").val());
        $costInfoFields.annualMileage.val($("#AverageMilesPerYear").val());

        var costPerGallon = $costInfoFields.fuel.val() * numberOfLtrToGallon;
        var numOfGallonsForAnnualMileage = $costInfoFields.annualMileage.val() / carInfo.mpg;

        //Calculate the costs and store them in a cost object.
        var annualResult = costPerGallon * numOfGallonsForAnnualMileage;

        var costs = {
            annualResult: annualResult.toFixed(2),
            monthlyResult: (annualResult / 12).toFixed(2),
            weeklyResult: (annualResult / 52).toFixed(2)
        };

        prefillResultsPage(costs);

    }

    function prefillResultsPage(costs) {
        //opening sentence of prices page
        setText("#ResultsMake", carInfo.make);
        setText("#ResultsModel", carInfo.model);
        setText("#ResultsAnnualMileage", $costInfoFields.annualMileage.val());
        setText("#ResultsFuelCost", "£" + $costInfoFields.fuel.val());

        //Results
        setText("#annualCostResult", "£" + costs.annualResult);
        setText("#monthlyCostResult", "£" + costs.monthlyResult);
        setText("#weeklyCostResult", "£" + costs.weeklyResult);
    }

    function otherQuestionsPageIsValid() {
        var mpgIsValid = numberInputCheck.apply($("#MpgValue"), []);
        var avgMilesIsValid = numberInputCheck.apply($("#AverageMilesPerYear"), []);
        var fuelCostIsValid = numberInputCheck.apply($("#fuelCostPerLitre"), []);
        var isValid = mpgIsValid && avgMilesIsValid && fuelCostIsValid;
        return isValid;
    }

    //this will ensure the two fuelCost related input values are kept in sync
    function syncFuelCosts() {
        var $this = $(this);
        var newVal = parseFloat($this.val());
        if (numberInputCheck.apply($this, [])) {
            $(".fuelCostInput").val(newVal.toFixed(2));
        }
    }

    //this will ensure the two fuelCost related input values are kept in sync
    function syncMpgCosts() {
        var $this = $(this);
        var newMpgVal = parseFloat($this.val());
        if (numberInputCheck.apply($this, [])) {
            carInfo.mpg = newMpgVal;
        }
    }

    function updateResults() {
        if (numberInputCheck.apply($("#fuelCostToggle"), [])) {
            calculateResult();
        }
    }

    function changeFuelCost(diff) {
        var newVal = parseFloat($("#fuelCostToggle").val()) + diff;
        $("#fuelCostToggle").val(newVal.toFixed(2)).trigger("change");
    }

    /* ----------Document ready----------*/
    $(document).ready(function () {

        //cache root element of widget to perform searches on.
        $fuelCostCalculator = $("#FuelCostCalculator");

        /*----------SetUp PageTransition function.----------*/
        // This fuction will deal with the transition from page to page, mainly dealing with the animation
        // The animation performed is dependant on the "progress" variable. 0 being the first page, 1 being the second up to 3 being the results. 
        pageTransition = (function (transition) {

            //the container for the back, try again and continue buttons
            var $navBar = $fuelCostCalculator.find(".page-nav");

            //the widget containing the social media links
            var $shareWidget = $fuelCostCalculator.find("#widget-share");

            transition.next = function () {
                movePages(function () { progress++; });
            };

            transition.previous = function () {
                movePages(function () { progress--; });
            };

            //takes the user back to the first page and clears the most recent car lookup info.
            transition.reset = function () {
                progress = 0;
                clearPrefilledCarLookupValues();
                updateCarDetails();
                animateTransition();

                $fuelCostCalculator.find("#panel4").fadeOut({
                    complete: function () {
                        $fuelCostCalculator.find("#panel1").fadeIn();
                    }
                });
            };

            function toggleFade(shouldBeShown) {
                var currentlyVisble = $(this).is(":visible");

                if (!currentlyVisble && shouldBeShown) {
                    $(this).fadeIn();
                    return;
                }

                if (currentlyVisble && !shouldBeShown) {
                    $(this).fadeOut();
                    return;
                }
            }

            function animateTransition() {
                toggleFade.apply($navBar, [(progress > 0 && progress !== 3)]); //hide nav bar on first page and results page
                toggleFade.apply($navBar.find(".TryAgain-Button"), [(progress === 1)]); //show try again button on second page. 
                toggleFade.apply($navBar.find(".Back-Button"), [(progress > 1)]); //show Back button after the second page. 
                toggleFade.apply($navBar.find(".Continue-Button"), [(progress === 1)]); //Show continue button on second page
                toggleFade.apply($shareWidget, [(progress === 0 || progress === 3)]); //show share widget on first and last page
                toggleFade.apply($navBar.find(".calculatButtonDiv"), [(progress === 2)]); //show calculate button on third page. 
                toggleFade.apply($fuelCostCalculator.find(".recalculatButtonDiv"), [(progress === 3)]); //Show recalc button on the results page			
            }

            function movePages(action) {
                function showNewPage() {
                    action();
                    animateTransition();
                    //Show next page regardless of page specific features
                    $fuelCostCalculator.find("#" + pageTransitionState[progress]).fadeIn();
                }

                $fuelCostCalculator.find("#" + pageTransitionState[progress]).fadeOut({ complete: showNewPage });
            }

            return transition;
        }({}));

        //Set up required cost calculation field information
        $costInfoFields = {
            mpg: $fuelCostCalculator.find("#mpg"),
            annualMileage: $fuelCostCalculator.find("#mileage"),
            fuel: $fuelCostCalculator.find("#fuel")
        };

        //This stops multiple server requests being made or page skips occuring.
        function preventDoubleClick() {
            var $this = $(this);
            if ($this.attr("disabled") !== true) {
                $this.attr("disabled", true);
                setTimeout(function () {
                    $this.attr("disabled", false);
                }, 1000);
            }
        }

        $fuelCostCalculator.find("button.nav-button, #findCar").click(preventDoubleClick);

        //event handlers
        $fuelCostCalculator.find("#findCar").click(findCarClickEvent);
        $fuelCostCalculator.find("#RegNumber").keyup(function (e) {
            var key = e.which;
            if (key === 13) {
                findCarClickEvent();
            }
        });
        $fuelCostCalculator.find(".Continue-Button").click(pageTransition.next);
        $fuelCostCalculator.find(".Back-Button, .TryAgain-Button").click(pageTransition.previous);

        $fuelCostCalculator.find("#Calculate").click(function () {
            if (otherQuestionsPageIsValid()) {
                calculateResult();
                pageTransition.next();
            }
        });
        $fuelCostCalculator.find("#Reset").click(pageTransition.reset);
        $fuelCostCalculator.find("#AverageMilesPerYear, #fuelCostPerLitre").blur(numberInputCheck);
        $fuelCostCalculator.find(".fuelCostInput").change(syncFuelCosts);
        $fuelCostCalculator.find("#fuelCostToggle").change(updateResults);
        $fuelCostCalculator.find("#MpgValue").blur(syncMpgCosts);

        $fuelCostCalculator.find("#increaseFuelCost").click(function () {
            changeFuelCost(0.01);
        });

        $fuelCostCalculator.find("#decreaseFuelCost").click(function () {
            changeFuelCost(-0.01);
        });

        return fuelcost;
    });

}(jQuery, {}));